import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'print-component',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})

/**
 * Print Component.
 */
export class PrintComponent {

  /**
   * Print element Id.
   */
  @Input() elementId = 'print-element';

  /**
   * Document file name.
   */
  @Input() fileName = 'print';

  /**
   * Print page with.
   */
  @Input() width = 190;

  /**
   * Print page height.
   * Auto computed if null.
   */
  @Input() height: number;

  /**
   * Print orientation.
   *  - Portrait  p
   *  - Landscape l
   */
  @Input() orientation: 'p' | 'portrait' | 'l' | 'landscape' = 'p';

  /**
   * Print page unit.
   */
  @Input() unit: 'pt' | 'em' | 'mm' | 'px' | 'in' | 'cm' | 'ex' | 'pc' = 'mm';

  /**
   * Print page format.
   */
  @Input() format = 'a4';

  /**
   * Before print event emitter.
   */
  @Output() before = new EventEmitter();

  /**
   * After print event emitter.
   */
  @Output() after = new EventEmitter();

  /**
   * Print component view.
   */
  @ViewChild('printComponent', {static: true}) printComponent;
  @ViewChild('printOptions', {static: true}) printOptions;

  /**
   * Print options.
   */
  options = [
    {id: 2, name: 'Download', icon: 'get_app'},
    {id: 1, name: 'Print', icon: 'print'}
  ];

  /**
   * Print option.
   */
  printOption = 1;

  /**
   * On change event..
   *
   * @param option Print option.
   */
  onChange(option) {
    if (option != null) {
      this.printComponent.nativeElement.style.display = 'none';

      this.printOption = option.id;
      const printEl = document.getElementById(this.elementId);

      this.before.emit(printEl);

      html2canvas(printEl).then(canvas => {
        const contentDataURL = canvas.toDataURL('image/jpeg', 1.0);

        const height = this.height ? this.height : canvas.height * this.width / canvas.width;

        const pdf = new jsPDF(this.orientation, this.unit, this.format);
        pdf.addImage(contentDataURL, 'JPEG', 10, 10, this.width, height);
        switch (+option.id || +option) {
          case 1:
            this.print(printEl, pdf);
            break;

          case 2:
            this.download(printEl, pdf);
            break;
        }
      });
    }

    this.printOptions.value = null;
    this.printOption = 1;
  }

  /**
   * Print document.
   *
   * @param pdf PDF document.
   */
  private print(printEl, pdf) {
    pdf.autoPrint();

    const docUrl = pdf.output('bloburl');
    // const iframe = document.getElementById('print-iframe');

    const newEmbedTag = document.createElement('embed');
    newEmbedTag.setAttribute('url', docUrl);
    newEmbedTag.setAttribute('type', 'application/pdf');

    const newObjectTag = document.createElement('object');
    newObjectTag.setAttribute('data', docUrl);
    newObjectTag.setAttribute('type', 'application/pdf');
    newObjectTag.appendChild(newEmbedTag);

    let iframe = document.getElementById('print-iframe') as HTMLIFrameElement;
    if (!iframe) {
      iframe = document.createElement('iframe') as HTMLIFrameElement;
      iframe.id = 'print-iframe';
      iframe.style.visibility = 'hidden';
      iframe.style.position = 'fixed';
      iframe.style.left = '-100%';
      iframe.setAttribute('frameborder', '0');

      document.body.appendChild(iframe);
    }

    iframe.contentWindow.document.body.innerHTML = '';
    iframe.contentWindow.document.body.appendChild(newObjectTag);
    iframe.contentWindow.onclose = () => {
    };

    // const printIframe = (iframe as HTMLIFrameElement).contentWindow;
    // printIframe.document.body.innerHTML = '';
    // printIframe.document.body.appendChild(newObjectTag);

    this.printComponent.nativeElement.style.display = '';
    this.after.emit(printEl);
  }

  /**
   * Download document.
   *
   * @param pdf PDF Document.
   */
  private download(printEl, pdf) {
    pdf.save(this.fileName + '.pdf');

    this.printComponent.nativeElement.style.display = '';
    this.after.emit(printEl);
  }
}
